import ConfirmationDialog from '@/components/ui/dialog-wrapper/ConfirmationDialog';
import { toastSomethingError } from '@/components/ui/toast-content';
import { useDeleteServerlessProject } from '@/service/serverless-gpu/hook';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { PATH_PAGE } from '@/router/path';
import { useNavigate } from 'react-router-dom';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';

const DeleteProject = ({ projectId }: { projectId: string }) => {
  const { workspaceId } = useParamWorkspaceId();
  const navigate = useNavigate();
  const { mutate: deleteProject } = useDeleteServerlessProject({
    onSuccess: () => {
      toast.success('Project deleted successfully');
      navigate(PATH_PAGE.dashboard.serverlessGPU.overview(workspaceId));
    },
    onError: () => {
      toastSomethingError();
    },
  });
  const handleDeleteProject = () => {
    deleteProject({
      project_id: projectId,
    });
  };

  return (
    <ConfirmationDialog
      title="Delete Project"
      message="Are you sure you want to delete this project? Once you delete a project, there is no going back. Please be certain."
      onConfirm={handleDeleteProject}
      confirmText="I understand, delete this project"
      isCancel={true}
      slots={{
        confirmButton: {
          variant: 'destructive',
        },
      }}
    >
      <Button variant="destructive">Delete Project</Button>
    </ConfirmationDialog>
  );
};

export default DeleteProject;
